import { ApolloClient } from 'apollo-client';
// import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloLink } from 'apollo-link';
import { createUploadLink } from 'apollo-upload-client'

//para digitalocean produccion uv bv =>
// const httpLink = createUploadLink({uri:'http://45.55.32.196:3000/graphql'})

//para digitalocean Produccion Servidor B DMZ ==> CC Manizales =>
const httpLink = createUploadLink({uri:'https://foropticcodisertpruebas.com/graphql'})

//para digitalocean Produccion Servidor A SMZ ==> CC Manizales =>
// const httpLink = createUploadLink({uri:'http://64.227.28.91:3000/graphql'})

//para digitalocean Produccion Servidor B DMZ ==> CC Manizales =>
// const httpLink = createUploadLink({uri:'https://superfibra.tech/graphql'})

// const httpLink = createUploadLink({uri:'http://localhost:3000/graphql'})
//para digitalocean bv =>
// const httpLink = createUploadLink({uri:'http://142.93.61.147:3000/graphql'})
//para digitalocean =>
// const httpLink = createUploadLink({uri:'http://104.248.69.56:3000/graphql'})
//para digitalocean foroptic
// const httpLink = createUploadLink({uri:'http://165.227.189.1:3000/graphql'})
//para digitalocean pruebas ultimas versiones
// const httpLink = createUploadLink({uri:'http://206.189.168.76:3000/graphql'})

const authMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext({
    headers: {
      "x-token": sessionStorage.getItem('token') || null,
    }
  });
  // console.log(forward)
  // console.log(operation)
  // console.log(forward(operation))
  // console.log(forward(operation)._subscriber)
  forward(operation).map(response => {
    // console.log("entro 2")
// console.log(response)
  })
  return forward(operation);
})

const authAfterware = new ApolloLink((operation, forward) => {
  // console.log("entro 1")
  // console.log(forward(operation))
  // console.log(forward(operation).length)
  return forward(operation).map(response => {
    // console.log("entro 2")
// console.log(response)
    const context = operation.getContext();
    // console.log(context);
    const { response: { headers } } = context;
    if (headers) {
      const token = headers.get("x-token");

      if (token) {
        sessionStorage.setItem("token", token);
      }
    }
    if(response.errors && response.errors.length){
      console.log("error autenticacion")
      if(response.errors[0].message==="No autenticado"){
        console.log(response.errors[0])
        sessionStorage.removeItem('token')
        window.location = "/"
      }
    };
    // console.log(response)
    return response;
  });
});

// console.log(authAfterware.concat(authMiddleware.concat(httpLink)))
// console.log(authMiddleware.concat(httpLink))


export default new ApolloClient({
  link: authAfterware.concat(authMiddleware.concat(httpLink)),
  cache: new InMemoryCache()
});

// export default client
